import { useState } from "react";
import { ChevronDown, Plus, Minus } from "lucide-react";
import { faqsData } from "@/data/content";

const FAQ = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  const faqs = faqsData;

  return (
    <section id="faq" className="py-16 md:py-20 px-4 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg text-xs font-black tracking-widest mb-4">
            FAQ
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black mb-4">Frequently Asked Questions</h2>
          <p className="text-lg text-gray-600">Everything you need to know about our onboarding services</p>
        </div>
        
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div 
              key={idx} 
              className={`border-2 rounded-xl overflow-hidden transition-all duration-300 ${
                openFAQ === idx 
                  ? 'border-red-500 shadow-lg shadow-red-500/10' 
                  : 'border-gray-200 hover:border-gray-300'
              }`}
              data-testid={`faq-item-${idx}`}
            >
              <button
                onClick={() => setOpenFAQ(openFAQ === idx ? null : idx)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition"
                aria-expanded={openFAQ === idx}
              >
                <h3 className="text-base md:text-lg font-bold text-black pr-4">{faq.q}</h3>
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openFAQ === idx ? 'bg-red-600 text-white rotate-0' : 'bg-gray-100 text-gray-600'
                }`}>
                  {openFAQ === idx ? <Minus size={18} /> : <Plus size={18} />}
                </div>
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openFAQ === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5 pt-1">
                  <p className="text-gray-600 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
